import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCommonStore } from '../stores/common';

export default function useLink() {
  const { locale } = useI18n();
  const common = useCommonStore();
  const queryStr = computed(() => `?locale=${locale.value}&theme=${common.theme}`);

  const transitUrl = computed(() => {
    if (process.env.VUE_APP_ENV === 'dev') {
      return `https://test-tp.tokenpocket.pro/transit-finance/${queryStr.value}`;
    } else {
      return `https://transit.finance/${queryStr.value}`;
    }
  });
  const swapUrl = computed(() => {
    if (process.env.VUE_APP_ENV === 'dev') {
      return `https://test-tp.tokenpocket.pro/dev/${queryStr.value}`;
    } else {
      return `https://swap.transit.finance/${queryStr.value}`;
    }
  });

  const swapMarketUrl = computed(() => {
    if (process.env.VUE_APP_ENV === 'dev') {
      return `https://test-tp.tokenpocket.pro/dev/${queryStr.value}#/market`;
    } else {
      return `https://swap.transit.finance/${queryStr.value}#/market`;
    }
  });

  const transitDaoUrl = computed(() => {
    return `https://transit.finance/${queryStr.value}#/stake`;
  });
  
  const transitDonationUrl = computed(() => {
    return `https://transit.finance/${queryStr.value}#/donation`;
  });

  const transitFeeUrl = computed(() => {
    return `https://transit.finance/${queryStr.value}#/fee`;
  });

  return { transitUrl, swapUrl, swapMarketUrl, transitDaoUrl, transitDonationUrl, transitFeeUrl };
}
